/**
 * @license Copyright 2019 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
 */

.simple-details--improvement {
  color: var(--improvement-text-color);
}

.simple-details--regression {
  color: var(--regression-text-color);
}

.simple-details__url-hostname {
  color: var(--secondary-text-color);
  margin-left: calc(var(--base-spacing) / 2);
  font-size: var(--subtext-font-size);
}
